<script lang="ts">
	import Advertising from './Advertising.svelte';
</script>

<div class="flex items-center justify-center relative h-70 w-75">
	<Advertising adId="poi-list" adFormat="300x250" showAdByDefault />
</div>
